/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddSessionToGroupRequest,
  CreateImportGroupRequest,
  CreateMappingProfileRequest,
  FinalizeUploadsRequestDto,
  ImportConfigurationRequestDto,
  ImportGroup,
  ImportProgressDto,
  ImportRowErrorDtoPagedResponseDto,
  ImportRowErrorStatus,
  ImportSessionDto,
  ImportType,
  LinkFieldsRequestDto,
  LinkPreviewDto,
  MappingPreviewDto,
  MappingProfileDto,
  MappingProfileSummaryDto,
  PreviewMappingRequestDto,
  RelationshipGraphDto,
  ResolveStagingRequest,
  SaveAsProfileRequest,
  StagingAction,
  StagingRecordDtoPagedResponseDto,
  StagingSummaryDto,
  StartImportSessionRequestDto,
  UpdateGroupOrderRequest,
  UpdateMappingProfileRequest,
  UpdateRelationshipsRequestDto,
  UpdateRowErrorRequestDto,
  ValidationSummaryDto,
} from '../models/index';
import {
    AddSessionToGroupRequestFromJSON,
    AddSessionToGroupRequestToJSON,
    CreateImportGroupRequestFromJSON,
    CreateImportGroupRequestToJSON,
    CreateMappingProfileRequestFromJSON,
    CreateMappingProfileRequestToJSON,
    FinalizeUploadsRequestDtoFromJSON,
    FinalizeUploadsRequestDtoToJSON,
    ImportConfigurationRequestDtoFromJSON,
    ImportConfigurationRequestDtoToJSON,
    ImportGroupFromJSON,
    ImportGroupToJSON,
    ImportProgressDtoFromJSON,
    ImportProgressDtoToJSON,
    ImportRowErrorDtoPagedResponseDtoFromJSON,
    ImportRowErrorDtoPagedResponseDtoToJSON,
    ImportRowErrorStatusFromJSON,
    ImportRowErrorStatusToJSON,
    ImportSessionDtoFromJSON,
    ImportSessionDtoToJSON,
    ImportTypeFromJSON,
    ImportTypeToJSON,
    LinkFieldsRequestDtoFromJSON,
    LinkFieldsRequestDtoToJSON,
    LinkPreviewDtoFromJSON,
    LinkPreviewDtoToJSON,
    MappingPreviewDtoFromJSON,
    MappingPreviewDtoToJSON,
    MappingProfileDtoFromJSON,
    MappingProfileDtoToJSON,
    MappingProfileSummaryDtoFromJSON,
    MappingProfileSummaryDtoToJSON,
    PreviewMappingRequestDtoFromJSON,
    PreviewMappingRequestDtoToJSON,
    RelationshipGraphDtoFromJSON,
    RelationshipGraphDtoToJSON,
    ResolveStagingRequestFromJSON,
    ResolveStagingRequestToJSON,
    SaveAsProfileRequestFromJSON,
    SaveAsProfileRequestToJSON,
    StagingActionFromJSON,
    StagingActionToJSON,
    StagingRecordDtoPagedResponseDtoFromJSON,
    StagingRecordDtoPagedResponseDtoToJSON,
    StagingSummaryDtoFromJSON,
    StagingSummaryDtoToJSON,
    StartImportSessionRequestDtoFromJSON,
    StartImportSessionRequestDtoToJSON,
    UpdateGroupOrderRequestFromJSON,
    UpdateGroupOrderRequestToJSON,
    UpdateMappingProfileRequestFromJSON,
    UpdateMappingProfileRequestToJSON,
    UpdateRelationshipsRequestDtoFromJSON,
    UpdateRelationshipsRequestDtoToJSON,
    UpdateRowErrorRequestDtoFromJSON,
    UpdateRowErrorRequestDtoToJSON,
    ValidationSummaryDtoFromJSON,
    ValidationSummaryDtoToJSON,
} from '../models/index';

export interface ImportAddSessionToGroupPOSTRequest {
    id: string;
    addSessionToGroupRequest?: AddSessionToGroupRequest;
}

export interface ImportApplyProfilePOSTRequest {
    cuid: string;
    profileId: string;
}

export interface ImportCreateGroupPOSTRequest {
    createImportGroupRequest?: CreateImportGroupRequest;
}

export interface ImportCreateMappingProfilePOSTRequest {
    createMappingProfileRequest?: CreateMappingProfileRequest;
}

export interface ImportDeleteGroupDELETERequest {
    id: string;
}

export interface ImportDeleteImportSessionDELETERequest {
    cuid: string;
}

export interface ImportDeleteMappingProfileDELETERequest {
    id: string;
}

export interface ImportFetchAddressesPOSTRequest {
    cuid: string;
}

export interface ImportFetchOsmBuildingForCompanyPOSTRequest {
    companyId: string;
}

export interface ImportFinalizeUploadsPOSTRequest {
    cuid: string;
    finalizeUploadsRequestDto?: FinalizeUploadsRequestDto;
}

export interface ImportGetAllMappingProfilesGETRequest {
    importType?: ImportType;
}

export interface ImportGetGroupGETRequest {
    id: string;
}

export interface ImportGetImportStatusGETRequest {
    cuid: string;
}

export interface ImportGetMappingProfilesGETRequest {
    cuid: string;
}

export interface ImportGetProgressGETRequest {
    cuid: string;
}

export interface ImportGetQueueJobStatusGETRequest {
    jobId: string;
}

export interface ImportGetRelationshipGraphGETRequest {
    cuid: string;
}

export interface ImportGetStagingRecordsGETRequest {
    cuid: string;
    page?: number;
    pageSize?: number;
    action?: StagingAction;
}

export interface ImportGetStagingSummaryGETRequest {
    cuid: string;
}

export interface ImportGetValidationResultsGETRequest {
    cuid: string;
    page?: number;
    pageSize?: number;
    status?: ImportRowErrorStatus;
}

export interface ImportGetValidationSummaryGETRequest {
    cuid: string;
}

export interface ImportLinkFieldsPOSTRequest {
    linkFieldsRequestDto?: LinkFieldsRequestDto;
}

export interface ImportPreviewLinksPOSTRequest {
    cuid: string;
}

export interface ImportPreviewMappingPOSTRequest {
    cuid: string;
    previewMappingRequestDto?: PreviewMappingRequestDto;
}

export interface ImportProcessImportPOSTRequest {
    cuid: string;
}

export interface ImportRemoveSessionFromGroupDELETERequest {
    id: string;
    sessionId: string;
}

export interface ImportResolveStagingConflictPUTRequest {
    cuid: string;
    id: string;
    resolveStagingRequest?: ResolveStagingRequest;
}

export interface ImportRevalidatePOSTRequest {
    cuid: string;
}

export interface ImportSaveAsProfilePOSTRequest {
    cuid: string;
    saveAsProfileRequest?: SaveAsProfileRequest;
}

export interface ImportSkipAllErrorsPOSTRequest {
    cuid: string;
}

export interface ImportSkipRowErrorPUTRequest {
    cuid: string;
    id: string;
}

export interface ImportStartImportSessionPOSTRequest {
    startImportSessionRequestDto?: StartImportSessionRequestDto;
}

export interface ImportStartOsmPopulationPOSTRequest {
    cuid: string;
}

export interface ImportStartStagingPOSTRequest {
    cuid: string;
}

export interface ImportUpdateConfigurationPUTRequest {
    cuid: string;
    importConfigurationRequestDto?: ImportConfigurationRequestDto;
}

export interface ImportUpdateGroupOrderPUTRequest {
    id: string;
    updateGroupOrderRequest?: UpdateGroupOrderRequest;
}

export interface ImportUpdateMappingProfilePUTRequest {
    id: string;
    updateMappingProfileRequest?: UpdateMappingProfileRequest;
}

export interface ImportUpdateRelationshipsPUTRequest {
    cuid: string;
    updateRelationshipsRequestDto?: UpdateRelationshipsRequestDto;
}

export interface ImportUpdateRowErrorPUTRequest {
    cuid: string;
    id: string;
    updateRowErrorRequestDto?: UpdateRowErrorRequestDto;
}

export interface ImportUploadFilePOSTRequest {
    file?: Blob;
    cuid?: string;
    order?: number;
}

/**
 * ImportApi - interface
 * 
 * @export
 * @interface ImportApiInterface
 */
export interface ImportApiInterface {
    /**
     * Creates request options for importAddSessionToGroupPOST without sending the request
     * @param {string} id 
     * @param {AddSessionToGroupRequest} [addSessionToGroupRequest] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importAddSessionToGroupPOSTRequestOpts(requestParameters: ImportAddSessionToGroupPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {AddSessionToGroupRequest} [addSessionToGroupRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importAddSessionToGroupPOSTRaw(requestParameters: ImportAddSessionToGroupPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importAddSessionToGroupPOST(requestParameters: ImportAddSessionToGroupPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importApplyProfilePOST without sending the request
     * @param {string} cuid 
     * @param {string} profileId 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importApplyProfilePOSTRequestOpts(requestParameters: ImportApplyProfilePOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importApplyProfilePOSTRaw(requestParameters: ImportApplyProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importApplyProfilePOST(requestParameters: ImportApplyProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importCreateGroupPOST without sending the request
     * @param {CreateImportGroupRequest} [createImportGroupRequest] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importCreateGroupPOSTRequestOpts(requestParameters: ImportCreateGroupPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CreateImportGroupRequest} [createImportGroupRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importCreateGroupPOSTRaw(requestParameters: ImportCreateGroupPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportGroup>>;

    /**
     */
    importCreateGroupPOST(requestParameters: ImportCreateGroupPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportGroup>;

    /**
     * Creates request options for importCreateMappingProfilePOST without sending the request
     * @param {CreateMappingProfileRequest} [createMappingProfileRequest] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importCreateMappingProfilePOSTRequestOpts(requestParameters: ImportCreateMappingProfilePOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CreateMappingProfileRequest} [createMappingProfileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importCreateMappingProfilePOSTRaw(requestParameters: ImportCreateMappingProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MappingProfileSummaryDto>>;

    /**
     */
    importCreateMappingProfilePOST(requestParameters: ImportCreateMappingProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MappingProfileSummaryDto>;

    /**
     * Creates request options for importDeleteGroupDELETE without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importDeleteGroupDELETERequestOpts(requestParameters: ImportDeleteGroupDELETERequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importDeleteGroupDELETERaw(requestParameters: ImportDeleteGroupDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importDeleteGroupDELETE(requestParameters: ImportDeleteGroupDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importDeleteImportSessionDELETE without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importDeleteImportSessionDELETERequestOpts(requestParameters: ImportDeleteImportSessionDELETERequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importDeleteImportSessionDELETERaw(requestParameters: ImportDeleteImportSessionDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importDeleteImportSessionDELETE(requestParameters: ImportDeleteImportSessionDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importDeleteMappingProfileDELETE without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importDeleteMappingProfileDELETERequestOpts(requestParameters: ImportDeleteMappingProfileDELETERequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importDeleteMappingProfileDELETERaw(requestParameters: ImportDeleteMappingProfileDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importDeleteMappingProfileDELETE(requestParameters: ImportDeleteMappingProfileDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importFetchAddressesPOST without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importFetchAddressesPOSTRequestOpts(requestParameters: ImportFetchAddressesPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importFetchAddressesPOSTRaw(requestParameters: ImportFetchAddressesPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importFetchAddressesPOST(requestParameters: ImportFetchAddressesPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importFetchOsmBuildingForCompanyPOST without sending the request
     * @param {string} companyId 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importFetchOsmBuildingForCompanyPOSTRequestOpts(requestParameters: ImportFetchOsmBuildingForCompanyPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importFetchOsmBuildingForCompanyPOSTRaw(requestParameters: ImportFetchOsmBuildingForCompanyPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importFetchOsmBuildingForCompanyPOST(requestParameters: ImportFetchOsmBuildingForCompanyPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importFinalizeUploadsPOST without sending the request
     * @param {string} cuid 
     * @param {FinalizeUploadsRequestDto} [finalizeUploadsRequestDto] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importFinalizeUploadsPOSTRequestOpts(requestParameters: ImportFinalizeUploadsPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {FinalizeUploadsRequestDto} [finalizeUploadsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importFinalizeUploadsPOSTRaw(requestParameters: ImportFinalizeUploadsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>>;

    /**
     */
    importFinalizeUploadsPOST(requestParameters: ImportFinalizeUploadsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto>;

    /**
     * Creates request options for importGetAllMappingProfilesGET without sending the request
     * @param {ImportType} [importType] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetAllMappingProfilesGETRequestOpts(requestParameters: ImportGetAllMappingProfilesGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {ImportType} [importType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetAllMappingProfilesGETRaw(requestParameters: ImportGetAllMappingProfilesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MappingProfileSummaryDto>>>;

    /**
     */
    importGetAllMappingProfilesGET(requestParameters: ImportGetAllMappingProfilesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MappingProfileSummaryDto>>;

    /**
     * Creates request options for importGetGroupGET without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetGroupGETRequestOpts(requestParameters: ImportGetGroupGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetGroupGETRaw(requestParameters: ImportGetGroupGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportGroup>>;

    /**
     */
    importGetGroupGET(requestParameters: ImportGetGroupGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportGroup>;

    /**
     * Creates request options for importGetGroupsGET without sending the request
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetGroupsGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetGroupsGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ImportGroup>>>;

    /**
     */
    importGetGroupsGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ImportGroup>>;

    /**
     * Creates request options for importGetImportSessionsGET without sending the request
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetImportSessionsGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetImportSessionsGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ImportSessionDto>>>;

    /**
     */
    importGetImportSessionsGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ImportSessionDto>>;

    /**
     * Creates request options for importGetImportStatusGET without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetImportStatusGETRequestOpts(requestParameters: ImportGetImportStatusGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetImportStatusGETRaw(requestParameters: ImportGetImportStatusGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>>;

    /**
     */
    importGetImportStatusGET(requestParameters: ImportGetImportStatusGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto>;

    /**
     * Creates request options for importGetMappingProfilesGET without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetMappingProfilesGETRequestOpts(requestParameters: ImportGetMappingProfilesGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetMappingProfilesGETRaw(requestParameters: ImportGetMappingProfilesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MappingProfileDto>>>;

    /**
     */
    importGetMappingProfilesGET(requestParameters: ImportGetMappingProfilesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MappingProfileDto>>;

    /**
     * Creates request options for importGetProgressGET without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetProgressGETRequestOpts(requestParameters: ImportGetProgressGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetProgressGETRaw(requestParameters: ImportGetProgressGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportProgressDto>>;

    /**
     */
    importGetProgressGET(requestParameters: ImportGetProgressGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportProgressDto>;

    /**
     * Creates request options for importGetQueueJobStatusGET without sending the request
     * @param {string} jobId 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetQueueJobStatusGETRequestOpts(requestParameters: ImportGetQueueJobStatusGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetQueueJobStatusGETRaw(requestParameters: ImportGetQueueJobStatusGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importGetQueueJobStatusGET(requestParameters: ImportGetQueueJobStatusGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importGetRelationshipGraphGET without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetRelationshipGraphGETRequestOpts(requestParameters: ImportGetRelationshipGraphGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetRelationshipGraphGETRaw(requestParameters: ImportGetRelationshipGraphGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipGraphDto>>;

    /**
     */
    importGetRelationshipGraphGET(requestParameters: ImportGetRelationshipGraphGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipGraphDto>;

    /**
     * Creates request options for importGetStagingRecordsGET without sending the request
     * @param {string} cuid 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {StagingAction} [action] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetStagingRecordsGETRequestOpts(requestParameters: ImportGetStagingRecordsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {StagingAction} [action] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetStagingRecordsGETRaw(requestParameters: ImportGetStagingRecordsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StagingRecordDtoPagedResponseDto>>;

    /**
     */
    importGetStagingRecordsGET(requestParameters: ImportGetStagingRecordsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StagingRecordDtoPagedResponseDto>;

    /**
     * Creates request options for importGetStagingSummaryGET without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetStagingSummaryGETRequestOpts(requestParameters: ImportGetStagingSummaryGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetStagingSummaryGETRaw(requestParameters: ImportGetStagingSummaryGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StagingSummaryDto>>;

    /**
     */
    importGetStagingSummaryGET(requestParameters: ImportGetStagingSummaryGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StagingSummaryDto>;

    /**
     * Creates request options for importGetValidationResultsGET without sending the request
     * @param {string} cuid 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {ImportRowErrorStatus} [status] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetValidationResultsGETRequestOpts(requestParameters: ImportGetValidationResultsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {ImportRowErrorStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetValidationResultsGETRaw(requestParameters: ImportGetValidationResultsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportRowErrorDtoPagedResponseDto>>;

    /**
     */
    importGetValidationResultsGET(requestParameters: ImportGetValidationResultsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportRowErrorDtoPagedResponseDto>;

    /**
     * Creates request options for importGetValidationSummaryGET without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetValidationSummaryGETRequestOpts(requestParameters: ImportGetValidationSummaryGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importGetValidationSummaryGETRaw(requestParameters: ImportGetValidationSummaryGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidationSummaryDto>>;

    /**
     */
    importGetValidationSummaryGET(requestParameters: ImportGetValidationSummaryGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidationSummaryDto>;

    /**
     * Creates request options for importLinkFieldsPOST without sending the request
     * @param {LinkFieldsRequestDto} [linkFieldsRequestDto] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importLinkFieldsPOSTRequestOpts(requestParameters: ImportLinkFieldsPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {LinkFieldsRequestDto} [linkFieldsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importLinkFieldsPOSTRaw(requestParameters: ImportLinkFieldsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>>;

    /**
     */
    importLinkFieldsPOST(requestParameters: ImportLinkFieldsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto>;

    /**
     * Creates request options for importPreviewLinksPOST without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importPreviewLinksPOSTRequestOpts(requestParameters: ImportPreviewLinksPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importPreviewLinksPOSTRaw(requestParameters: ImportPreviewLinksPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkPreviewDto>>;

    /**
     */
    importPreviewLinksPOST(requestParameters: ImportPreviewLinksPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkPreviewDto>;

    /**
     * Creates request options for importPreviewMappingPOST without sending the request
     * @param {string} cuid 
     * @param {PreviewMappingRequestDto} [previewMappingRequestDto] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importPreviewMappingPOSTRequestOpts(requestParameters: ImportPreviewMappingPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {PreviewMappingRequestDto} [previewMappingRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importPreviewMappingPOSTRaw(requestParameters: ImportPreviewMappingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MappingPreviewDto>>;

    /**
     */
    importPreviewMappingPOST(requestParameters: ImportPreviewMappingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MappingPreviewDto>;

    /**
     * Creates request options for importProcessImportPOST without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importProcessImportPOSTRequestOpts(requestParameters: ImportProcessImportPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importProcessImportPOSTRaw(requestParameters: ImportProcessImportPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importProcessImportPOST(requestParameters: ImportProcessImportPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importRemoveSessionFromGroupDELETE without sending the request
     * @param {string} id 
     * @param {string} sessionId 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importRemoveSessionFromGroupDELETERequestOpts(requestParameters: ImportRemoveSessionFromGroupDELETERequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importRemoveSessionFromGroupDELETERaw(requestParameters: ImportRemoveSessionFromGroupDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importRemoveSessionFromGroupDELETE(requestParameters: ImportRemoveSessionFromGroupDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importResolveStagingConflictPUT without sending the request
     * @param {string} cuid 
     * @param {string} id 
     * @param {ResolveStagingRequest} [resolveStagingRequest] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importResolveStagingConflictPUTRequestOpts(requestParameters: ImportResolveStagingConflictPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {string} id 
     * @param {ResolveStagingRequest} [resolveStagingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importResolveStagingConflictPUTRaw(requestParameters: ImportResolveStagingConflictPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importResolveStagingConflictPUT(requestParameters: ImportResolveStagingConflictPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importRevalidatePOST without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importRevalidatePOSTRequestOpts(requestParameters: ImportRevalidatePOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importRevalidatePOSTRaw(requestParameters: ImportRevalidatePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importRevalidatePOST(requestParameters: ImportRevalidatePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importSaveAsProfilePOST without sending the request
     * @param {string} cuid 
     * @param {SaveAsProfileRequest} [saveAsProfileRequest] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importSaveAsProfilePOSTRequestOpts(requestParameters: ImportSaveAsProfilePOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {SaveAsProfileRequest} [saveAsProfileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importSaveAsProfilePOSTRaw(requestParameters: ImportSaveAsProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MappingProfileSummaryDto>>;

    /**
     */
    importSaveAsProfilePOST(requestParameters: ImportSaveAsProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MappingProfileSummaryDto>;

    /**
     * Creates request options for importSkipAllErrorsPOST without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importSkipAllErrorsPOSTRequestOpts(requestParameters: ImportSkipAllErrorsPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importSkipAllErrorsPOSTRaw(requestParameters: ImportSkipAllErrorsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importSkipAllErrorsPOST(requestParameters: ImportSkipAllErrorsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importSkipRowErrorPUT without sending the request
     * @param {string} cuid 
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importSkipRowErrorPUTRequestOpts(requestParameters: ImportSkipRowErrorPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importSkipRowErrorPUTRaw(requestParameters: ImportSkipRowErrorPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importSkipRowErrorPUT(requestParameters: ImportSkipRowErrorPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importStartImportSessionPOST without sending the request
     * @param {StartImportSessionRequestDto} [startImportSessionRequestDto] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importStartImportSessionPOSTRequestOpts(requestParameters: ImportStartImportSessionPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {StartImportSessionRequestDto} [startImportSessionRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importStartImportSessionPOSTRaw(requestParameters: ImportStartImportSessionPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>>;

    /**
     */
    importStartImportSessionPOST(requestParameters: ImportStartImportSessionPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto>;

    /**
     * Creates request options for importStartOsmPopulationPOST without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importStartOsmPopulationPOSTRequestOpts(requestParameters: ImportStartOsmPopulationPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importStartOsmPopulationPOSTRaw(requestParameters: ImportStartOsmPopulationPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importStartOsmPopulationPOST(requestParameters: ImportStartOsmPopulationPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importStartStagingPOST without sending the request
     * @param {string} cuid 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importStartStagingPOSTRequestOpts(requestParameters: ImportStartStagingPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importStartStagingPOSTRaw(requestParameters: ImportStartStagingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importStartStagingPOST(requestParameters: ImportStartStagingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importUpdateConfigurationPUT without sending the request
     * @param {string} cuid 
     * @param {ImportConfigurationRequestDto} [importConfigurationRequestDto] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateConfigurationPUTRequestOpts(requestParameters: ImportUpdateConfigurationPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {ImportConfigurationRequestDto} [importConfigurationRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateConfigurationPUTRaw(requestParameters: ImportUpdateConfigurationPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>>;

    /**
     */
    importUpdateConfigurationPUT(requestParameters: ImportUpdateConfigurationPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto>;

    /**
     * Creates request options for importUpdateGroupOrderPUT without sending the request
     * @param {string} id 
     * @param {UpdateGroupOrderRequest} [updateGroupOrderRequest] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateGroupOrderPUTRequestOpts(requestParameters: ImportUpdateGroupOrderPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateGroupOrderRequest} [updateGroupOrderRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateGroupOrderPUTRaw(requestParameters: ImportUpdateGroupOrderPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importUpdateGroupOrderPUT(requestParameters: ImportUpdateGroupOrderPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importUpdateMappingProfilePUT without sending the request
     * @param {string} id 
     * @param {UpdateMappingProfileRequest} [updateMappingProfileRequest] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateMappingProfilePUTRequestOpts(requestParameters: ImportUpdateMappingProfilePUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateMappingProfileRequest} [updateMappingProfileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateMappingProfilePUTRaw(requestParameters: ImportUpdateMappingProfilePUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MappingProfileSummaryDto>>;

    /**
     */
    importUpdateMappingProfilePUT(requestParameters: ImportUpdateMappingProfilePUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MappingProfileSummaryDto>;

    /**
     * Creates request options for importUpdateRelationshipsPUT without sending the request
     * @param {string} cuid 
     * @param {UpdateRelationshipsRequestDto} [updateRelationshipsRequestDto] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateRelationshipsPUTRequestOpts(requestParameters: ImportUpdateRelationshipsPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {UpdateRelationshipsRequestDto} [updateRelationshipsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateRelationshipsPUTRaw(requestParameters: ImportUpdateRelationshipsPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importUpdateRelationshipsPUT(requestParameters: ImportUpdateRelationshipsPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importUpdateRowErrorPUT without sending the request
     * @param {string} cuid 
     * @param {string} id 
     * @param {UpdateRowErrorRequestDto} [updateRowErrorRequestDto] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateRowErrorPUTRequestOpts(requestParameters: ImportUpdateRowErrorPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} cuid 
     * @param {string} id 
     * @param {UpdateRowErrorRequestDto} [updateRowErrorRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUpdateRowErrorPUTRaw(requestParameters: ImportUpdateRowErrorPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importUpdateRowErrorPUT(requestParameters: ImportUpdateRowErrorPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for importUploadFilePOST without sending the request
     * @param {Blob} [file] 
     * @param {string} [cuid] 
     * @param {number} [order] 
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUploadFilePOSTRequestOpts(requestParameters: ImportUploadFilePOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {Blob} [file] 
     * @param {string} [cuid] 
     * @param {number} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApiInterface
     */
    importUploadFilePOSTRaw(requestParameters: ImportUploadFilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>>;

    /**
     */
    importUploadFilePOST(requestParameters: ImportUploadFilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto>;

}

/**
 * 
 */
export class ImportApi extends runtime.BaseAPI implements ImportApiInterface {

    /**
     * Creates request options for importAddSessionToGroupPOST without sending the request
     */
    async importAddSessionToGroupPOSTRequestOpts(requestParameters: ImportAddSessionToGroupPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importAddSessionToGroupPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/groups/{id}/sessions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddSessionToGroupRequestToJSON(requestParameters['addSessionToGroupRequest']),
        };
    }

    /**
     */
    async importAddSessionToGroupPOSTRaw(requestParameters: ImportAddSessionToGroupPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importAddSessionToGroupPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importAddSessionToGroupPOST(requestParameters: ImportAddSessionToGroupPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importAddSessionToGroupPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importApplyProfilePOST without sending the request
     */
    async importApplyProfilePOSTRequestOpts(requestParameters: ImportApplyProfilePOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importApplyProfilePOST().'
            );
        }

        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling importApplyProfilePOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/apply-profile/{profileId}`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));
        urlPath = urlPath.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importApplyProfilePOSTRaw(requestParameters: ImportApplyProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importApplyProfilePOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importApplyProfilePOST(requestParameters: ImportApplyProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importApplyProfilePOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importCreateGroupPOST without sending the request
     */
    async importCreateGroupPOSTRequestOpts(requestParameters: ImportCreateGroupPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/groups`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateImportGroupRequestToJSON(requestParameters['createImportGroupRequest']),
        };
    }

    /**
     */
    async importCreateGroupPOSTRaw(requestParameters: ImportCreateGroupPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportGroup>> {
        const requestOptions = await this.importCreateGroupPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportGroupFromJSON(jsonValue));
    }

    /**
     */
    async importCreateGroupPOST(requestParameters: ImportCreateGroupPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportGroup> {
        const response = await this.importCreateGroupPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importCreateMappingProfilePOST without sending the request
     */
    async importCreateMappingProfilePOSTRequestOpts(requestParameters: ImportCreateMappingProfilePOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/mapping-profiles`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMappingProfileRequestToJSON(requestParameters['createMappingProfileRequest']),
        };
    }

    /**
     */
    async importCreateMappingProfilePOSTRaw(requestParameters: ImportCreateMappingProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MappingProfileSummaryDto>> {
        const requestOptions = await this.importCreateMappingProfilePOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MappingProfileSummaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async importCreateMappingProfilePOST(requestParameters: ImportCreateMappingProfilePOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MappingProfileSummaryDto> {
        const response = await this.importCreateMappingProfilePOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importDeleteGroupDELETE without sending the request
     */
    async importDeleteGroupDELETERequestOpts(requestParameters: ImportDeleteGroupDELETERequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importDeleteGroupDELETE().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importDeleteGroupDELETERaw(requestParameters: ImportDeleteGroupDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importDeleteGroupDELETERequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importDeleteGroupDELETE(requestParameters: ImportDeleteGroupDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importDeleteGroupDELETERaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importDeleteImportSessionDELETE without sending the request
     */
    async importDeleteImportSessionDELETERequestOpts(requestParameters: ImportDeleteImportSessionDELETERequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importDeleteImportSessionDELETE().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importDeleteImportSessionDELETERaw(requestParameters: ImportDeleteImportSessionDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importDeleteImportSessionDELETERequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importDeleteImportSessionDELETE(requestParameters: ImportDeleteImportSessionDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importDeleteImportSessionDELETERaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importDeleteMappingProfileDELETE without sending the request
     */
    async importDeleteMappingProfileDELETERequestOpts(requestParameters: ImportDeleteMappingProfileDELETERequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importDeleteMappingProfileDELETE().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/mapping-profiles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importDeleteMappingProfileDELETERaw(requestParameters: ImportDeleteMappingProfileDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importDeleteMappingProfileDELETERequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importDeleteMappingProfileDELETE(requestParameters: ImportDeleteMappingProfileDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importDeleteMappingProfileDELETERaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importFetchAddressesPOST without sending the request
     */
    async importFetchAddressesPOSTRequestOpts(requestParameters: ImportFetchAddressesPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importFetchAddressesPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/fetch-addresses`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importFetchAddressesPOSTRaw(requestParameters: ImportFetchAddressesPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importFetchAddressesPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importFetchAddressesPOST(requestParameters: ImportFetchAddressesPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importFetchAddressesPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importFetchOsmBuildingForCompanyPOST without sending the request
     */
    async importFetchOsmBuildingForCompanyPOSTRequestOpts(requestParameters: ImportFetchOsmBuildingForCompanyPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling importFetchOsmBuildingForCompanyPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/companies/{companyId}/geo-spatial/fetch-osm-building`;
        urlPath = urlPath.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importFetchOsmBuildingForCompanyPOSTRaw(requestParameters: ImportFetchOsmBuildingForCompanyPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importFetchOsmBuildingForCompanyPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importFetchOsmBuildingForCompanyPOST(requestParameters: ImportFetchOsmBuildingForCompanyPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importFetchOsmBuildingForCompanyPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importFinalizeUploadsPOST without sending the request
     */
    async importFinalizeUploadsPOSTRequestOpts(requestParameters: ImportFinalizeUploadsPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importFinalizeUploadsPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/{cuid}/finalize-uploads`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FinalizeUploadsRequestDtoToJSON(requestParameters['finalizeUploadsRequestDto']),
        };
    }

    /**
     */
    async importFinalizeUploadsPOSTRaw(requestParameters: ImportFinalizeUploadsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>> {
        const requestOptions = await this.importFinalizeUploadsPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportSessionDtoFromJSON(jsonValue));
    }

    /**
     */
    async importFinalizeUploadsPOST(requestParameters: ImportFinalizeUploadsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto> {
        const response = await this.importFinalizeUploadsPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetAllMappingProfilesGET without sending the request
     */
    async importGetAllMappingProfilesGETRequestOpts(requestParameters: ImportGetAllMappingProfilesGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['importType'] != null) {
            queryParameters['importType'] = requestParameters['importType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/mapping-profiles`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetAllMappingProfilesGETRaw(requestParameters: ImportGetAllMappingProfilesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MappingProfileSummaryDto>>> {
        const requestOptions = await this.importGetAllMappingProfilesGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MappingProfileSummaryDtoFromJSON));
    }

    /**
     */
    async importGetAllMappingProfilesGET(requestParameters: ImportGetAllMappingProfilesGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MappingProfileSummaryDto>> {
        const response = await this.importGetAllMappingProfilesGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetGroupGET without sending the request
     */
    async importGetGroupGETRequestOpts(requestParameters: ImportGetGroupGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importGetGroupGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetGroupGETRaw(requestParameters: ImportGetGroupGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportGroup>> {
        const requestOptions = await this.importGetGroupGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportGroupFromJSON(jsonValue));
    }

    /**
     */
    async importGetGroupGET(requestParameters: ImportGetGroupGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportGroup> {
        const response = await this.importGetGroupGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetGroupsGET without sending the request
     */
    async importGetGroupsGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/groups`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetGroupsGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ImportGroup>>> {
        const requestOptions = await this.importGetGroupsGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImportGroupFromJSON));
    }

    /**
     */
    async importGetGroupsGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ImportGroup>> {
        const response = await this.importGetGroupsGETRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetImportSessionsGET without sending the request
     */
    async importGetImportSessionsGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/active-sessions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetImportSessionsGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ImportSessionDto>>> {
        const requestOptions = await this.importGetImportSessionsGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImportSessionDtoFromJSON));
    }

    /**
     */
    async importGetImportSessionsGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ImportSessionDto>> {
        const response = await this.importGetImportSessionsGETRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetImportStatusGET without sending the request
     */
    async importGetImportStatusGETRequestOpts(requestParameters: ImportGetImportStatusGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importGetImportStatusGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/status`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetImportStatusGETRaw(requestParameters: ImportGetImportStatusGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>> {
        const requestOptions = await this.importGetImportStatusGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportSessionDtoFromJSON(jsonValue));
    }

    /**
     */
    async importGetImportStatusGET(requestParameters: ImportGetImportStatusGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto> {
        const response = await this.importGetImportStatusGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetMappingProfilesGET without sending the request
     */
    async importGetMappingProfilesGETRequestOpts(requestParameters: ImportGetMappingProfilesGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importGetMappingProfilesGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/mapping-profiles`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetMappingProfilesGETRaw(requestParameters: ImportGetMappingProfilesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MappingProfileDto>>> {
        const requestOptions = await this.importGetMappingProfilesGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MappingProfileDtoFromJSON));
    }

    /**
     */
    async importGetMappingProfilesGET(requestParameters: ImportGetMappingProfilesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MappingProfileDto>> {
        const response = await this.importGetMappingProfilesGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetProgressGET without sending the request
     */
    async importGetProgressGETRequestOpts(requestParameters: ImportGetProgressGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importGetProgressGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/progress`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetProgressGETRaw(requestParameters: ImportGetProgressGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportProgressDto>> {
        const requestOptions = await this.importGetProgressGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportProgressDtoFromJSON(jsonValue));
    }

    /**
     */
    async importGetProgressGET(requestParameters: ImportGetProgressGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportProgressDto> {
        const response = await this.importGetProgressGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetQueueJobStatusGET without sending the request
     */
    async importGetQueueJobStatusGETRequestOpts(requestParameters: ImportGetQueueJobStatusGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['jobId'] == null) {
            throw new runtime.RequiredError(
                'jobId',
                'Required parameter "jobId" was null or undefined when calling importGetQueueJobStatusGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/queue/jobs/{jobId}`;
        urlPath = urlPath.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters['jobId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetQueueJobStatusGETRaw(requestParameters: ImportGetQueueJobStatusGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importGetQueueJobStatusGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importGetQueueJobStatusGET(requestParameters: ImportGetQueueJobStatusGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importGetQueueJobStatusGETRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importGetRelationshipGraphGET without sending the request
     */
    async importGetRelationshipGraphGETRequestOpts(requestParameters: ImportGetRelationshipGraphGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importGetRelationshipGraphGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/relationship-graph`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetRelationshipGraphGETRaw(requestParameters: ImportGetRelationshipGraphGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipGraphDto>> {
        const requestOptions = await this.importGetRelationshipGraphGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipGraphDtoFromJSON(jsonValue));
    }

    /**
     */
    async importGetRelationshipGraphGET(requestParameters: ImportGetRelationshipGraphGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipGraphDto> {
        const response = await this.importGetRelationshipGraphGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetStagingRecordsGET without sending the request
     */
    async importGetStagingRecordsGETRequestOpts(requestParameters: ImportGetStagingRecordsGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importGetStagingRecordsGET().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['action'] != null) {
            queryParameters['action'] = requestParameters['action'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/staging-records`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetStagingRecordsGETRaw(requestParameters: ImportGetStagingRecordsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StagingRecordDtoPagedResponseDto>> {
        const requestOptions = await this.importGetStagingRecordsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StagingRecordDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async importGetStagingRecordsGET(requestParameters: ImportGetStagingRecordsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StagingRecordDtoPagedResponseDto> {
        const response = await this.importGetStagingRecordsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetStagingSummaryGET without sending the request
     */
    async importGetStagingSummaryGETRequestOpts(requestParameters: ImportGetStagingSummaryGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importGetStagingSummaryGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/staging-summary`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetStagingSummaryGETRaw(requestParameters: ImportGetStagingSummaryGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StagingSummaryDto>> {
        const requestOptions = await this.importGetStagingSummaryGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StagingSummaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async importGetStagingSummaryGET(requestParameters: ImportGetStagingSummaryGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StagingSummaryDto> {
        const response = await this.importGetStagingSummaryGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetValidationResultsGET without sending the request
     */
    async importGetValidationResultsGETRequestOpts(requestParameters: ImportGetValidationResultsGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importGetValidationResultsGET().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/validation-results`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetValidationResultsGETRaw(requestParameters: ImportGetValidationResultsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportRowErrorDtoPagedResponseDto>> {
        const requestOptions = await this.importGetValidationResultsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportRowErrorDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async importGetValidationResultsGET(requestParameters: ImportGetValidationResultsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportRowErrorDtoPagedResponseDto> {
        const response = await this.importGetValidationResultsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importGetValidationSummaryGET without sending the request
     */
    async importGetValidationSummaryGETRequestOpts(requestParameters: ImportGetValidationSummaryGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importGetValidationSummaryGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/validation-summary`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importGetValidationSummaryGETRaw(requestParameters: ImportGetValidationSummaryGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidationSummaryDto>> {
        const requestOptions = await this.importGetValidationSummaryGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationSummaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async importGetValidationSummaryGET(requestParameters: ImportGetValidationSummaryGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidationSummaryDto> {
        const response = await this.importGetValidationSummaryGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importLinkFieldsPOST without sending the request
     */
    async importLinkFieldsPOSTRequestOpts(requestParameters: ImportLinkFieldsPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/link`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkFieldsRequestDtoToJSON(requestParameters['linkFieldsRequestDto']),
        };
    }

    /**
     */
    async importLinkFieldsPOSTRaw(requestParameters: ImportLinkFieldsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>> {
        const requestOptions = await this.importLinkFieldsPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportSessionDtoFromJSON(jsonValue));
    }

    /**
     */
    async importLinkFieldsPOST(requestParameters: ImportLinkFieldsPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto> {
        const response = await this.importLinkFieldsPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importPreviewLinksPOST without sending the request
     */
    async importPreviewLinksPOSTRequestOpts(requestParameters: ImportPreviewLinksPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importPreviewLinksPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/preview-links`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importPreviewLinksPOSTRaw(requestParameters: ImportPreviewLinksPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkPreviewDto>> {
        const requestOptions = await this.importPreviewLinksPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkPreviewDtoFromJSON(jsonValue));
    }

    /**
     */
    async importPreviewLinksPOST(requestParameters: ImportPreviewLinksPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkPreviewDto> {
        const response = await this.importPreviewLinksPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importPreviewMappingPOST without sending the request
     */
    async importPreviewMappingPOSTRequestOpts(requestParameters: ImportPreviewMappingPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importPreviewMappingPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/{cuid}/preview-mapping`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreviewMappingRequestDtoToJSON(requestParameters['previewMappingRequestDto']),
        };
    }

    /**
     */
    async importPreviewMappingPOSTRaw(requestParameters: ImportPreviewMappingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MappingPreviewDto>> {
        const requestOptions = await this.importPreviewMappingPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MappingPreviewDtoFromJSON(jsonValue));
    }

    /**
     */
    async importPreviewMappingPOST(requestParameters: ImportPreviewMappingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MappingPreviewDto> {
        const response = await this.importPreviewMappingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importProcessImportPOST without sending the request
     */
    async importProcessImportPOSTRequestOpts(requestParameters: ImportProcessImportPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importProcessImportPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/process`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importProcessImportPOSTRaw(requestParameters: ImportProcessImportPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importProcessImportPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importProcessImportPOST(requestParameters: ImportProcessImportPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importProcessImportPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importRemoveSessionFromGroupDELETE without sending the request
     */
    async importRemoveSessionFromGroupDELETERequestOpts(requestParameters: ImportRemoveSessionFromGroupDELETERequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importRemoveSessionFromGroupDELETE().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling importRemoveSessionFromGroupDELETE().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/groups/{id}/sessions/{sessionId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importRemoveSessionFromGroupDELETERaw(requestParameters: ImportRemoveSessionFromGroupDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importRemoveSessionFromGroupDELETERequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importRemoveSessionFromGroupDELETE(requestParameters: ImportRemoveSessionFromGroupDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importRemoveSessionFromGroupDELETERaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importResolveStagingConflictPUT without sending the request
     */
    async importResolveStagingConflictPUTRequestOpts(requestParameters: ImportResolveStagingConflictPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importResolveStagingConflictPUT().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importResolveStagingConflictPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/{cuid}/staging-records/{id}`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ResolveStagingRequestToJSON(requestParameters['resolveStagingRequest']),
        };
    }

    /**
     */
    async importResolveStagingConflictPUTRaw(requestParameters: ImportResolveStagingConflictPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importResolveStagingConflictPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importResolveStagingConflictPUT(requestParameters: ImportResolveStagingConflictPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importResolveStagingConflictPUTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importRevalidatePOST without sending the request
     */
    async importRevalidatePOSTRequestOpts(requestParameters: ImportRevalidatePOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importRevalidatePOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/revalidate`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importRevalidatePOSTRaw(requestParameters: ImportRevalidatePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importRevalidatePOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importRevalidatePOST(requestParameters: ImportRevalidatePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importRevalidatePOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importSaveAsProfilePOST without sending the request
     */
    async importSaveAsProfilePOSTRequestOpts(requestParameters: ImportSaveAsProfilePOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importSaveAsProfilePOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/{cuid}/save-as-profile`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAsProfileRequestToJSON(requestParameters['saveAsProfileRequest']),
        };
    }

    /**
     */
    async importSaveAsProfilePOSTRaw(requestParameters: ImportSaveAsProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MappingProfileSummaryDto>> {
        const requestOptions = await this.importSaveAsProfilePOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MappingProfileSummaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async importSaveAsProfilePOST(requestParameters: ImportSaveAsProfilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MappingProfileSummaryDto> {
        const response = await this.importSaveAsProfilePOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importSkipAllErrorsPOST without sending the request
     */
    async importSkipAllErrorsPOSTRequestOpts(requestParameters: ImportSkipAllErrorsPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importSkipAllErrorsPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/validation-results/skip-all`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importSkipAllErrorsPOSTRaw(requestParameters: ImportSkipAllErrorsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importSkipAllErrorsPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importSkipAllErrorsPOST(requestParameters: ImportSkipAllErrorsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importSkipAllErrorsPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importSkipRowErrorPUT without sending the request
     */
    async importSkipRowErrorPUTRequestOpts(requestParameters: ImportSkipRowErrorPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importSkipRowErrorPUT().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importSkipRowErrorPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/validation-results/{id}/skip`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importSkipRowErrorPUTRaw(requestParameters: ImportSkipRowErrorPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importSkipRowErrorPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importSkipRowErrorPUT(requestParameters: ImportSkipRowErrorPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importSkipRowErrorPUTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importStartImportSessionPOST without sending the request
     */
    async importStartImportSessionPOSTRequestOpts(requestParameters: ImportStartImportSessionPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartImportSessionRequestDtoToJSON(requestParameters['startImportSessionRequestDto']),
        };
    }

    /**
     */
    async importStartImportSessionPOSTRaw(requestParameters: ImportStartImportSessionPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>> {
        const requestOptions = await this.importStartImportSessionPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportSessionDtoFromJSON(jsonValue));
    }

    /**
     */
    async importStartImportSessionPOST(requestParameters: ImportStartImportSessionPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto> {
        const response = await this.importStartImportSessionPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importStartOsmPopulationPOST without sending the request
     */
    async importStartOsmPopulationPOSTRequestOpts(requestParameters: ImportStartOsmPopulationPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importStartOsmPopulationPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/geo-spatial/start-osm-population`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importStartOsmPopulationPOSTRaw(requestParameters: ImportStartOsmPopulationPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importStartOsmPopulationPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importStartOsmPopulationPOST(requestParameters: ImportStartOsmPopulationPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importStartOsmPopulationPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importStartStagingPOST without sending the request
     */
    async importStartStagingPOSTRequestOpts(requestParameters: ImportStartStagingPOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importStartStagingPOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Import/{cuid}/stage`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async importStartStagingPOSTRaw(requestParameters: ImportStartStagingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importStartStagingPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importStartStagingPOST(requestParameters: ImportStartStagingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importStartStagingPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importUpdateConfigurationPUT without sending the request
     */
    async importUpdateConfigurationPUTRequestOpts(requestParameters: ImportUpdateConfigurationPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importUpdateConfigurationPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/{cuid}/configuration`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ImportConfigurationRequestDtoToJSON(requestParameters['importConfigurationRequestDto']),
        };
    }

    /**
     */
    async importUpdateConfigurationPUTRaw(requestParameters: ImportUpdateConfigurationPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>> {
        const requestOptions = await this.importUpdateConfigurationPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportSessionDtoFromJSON(jsonValue));
    }

    /**
     */
    async importUpdateConfigurationPUT(requestParameters: ImportUpdateConfigurationPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto> {
        const response = await this.importUpdateConfigurationPUTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importUpdateGroupOrderPUT without sending the request
     */
    async importUpdateGroupOrderPUTRequestOpts(requestParameters: ImportUpdateGroupOrderPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importUpdateGroupOrderPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/groups/{id}/order`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGroupOrderRequestToJSON(requestParameters['updateGroupOrderRequest']),
        };
    }

    /**
     */
    async importUpdateGroupOrderPUTRaw(requestParameters: ImportUpdateGroupOrderPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importUpdateGroupOrderPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importUpdateGroupOrderPUT(requestParameters: ImportUpdateGroupOrderPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importUpdateGroupOrderPUTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importUpdateMappingProfilePUT without sending the request
     */
    async importUpdateMappingProfilePUTRequestOpts(requestParameters: ImportUpdateMappingProfilePUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importUpdateMappingProfilePUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/mapping-profiles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMappingProfileRequestToJSON(requestParameters['updateMappingProfileRequest']),
        };
    }

    /**
     */
    async importUpdateMappingProfilePUTRaw(requestParameters: ImportUpdateMappingProfilePUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MappingProfileSummaryDto>> {
        const requestOptions = await this.importUpdateMappingProfilePUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MappingProfileSummaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async importUpdateMappingProfilePUT(requestParameters: ImportUpdateMappingProfilePUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MappingProfileSummaryDto> {
        const response = await this.importUpdateMappingProfilePUTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importUpdateRelationshipsPUT without sending the request
     */
    async importUpdateRelationshipsPUTRequestOpts(requestParameters: ImportUpdateRelationshipsPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importUpdateRelationshipsPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/{cuid}/relationships`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRelationshipsRequestDtoToJSON(requestParameters['updateRelationshipsRequestDto']),
        };
    }

    /**
     */
    async importUpdateRelationshipsPUTRaw(requestParameters: ImportUpdateRelationshipsPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importUpdateRelationshipsPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importUpdateRelationshipsPUT(requestParameters: ImportUpdateRelationshipsPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importUpdateRelationshipsPUTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importUpdateRowErrorPUT without sending the request
     */
    async importUpdateRowErrorPUTRequestOpts(requestParameters: ImportUpdateRowErrorPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cuid'] == null) {
            throw new runtime.RequiredError(
                'cuid',
                'Required parameter "cuid" was null or undefined when calling importUpdateRowErrorPUT().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling importUpdateRowErrorPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Import/{cuid}/validation-results/{id}`;
        urlPath = urlPath.replace(`{${"cuid"}}`, encodeURIComponent(String(requestParameters['cuid'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRowErrorRequestDtoToJSON(requestParameters['updateRowErrorRequestDto']),
        };
    }

    /**
     */
    async importUpdateRowErrorPUTRaw(requestParameters: ImportUpdateRowErrorPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importUpdateRowErrorPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importUpdateRowErrorPUT(requestParameters: ImportUpdateRowErrorPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importUpdateRowErrorPUTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for importUploadFilePOST without sending the request
     */
    async importUploadFilePOSTRequestOpts(requestParameters: ImportUploadFilePOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['cuid'] != null) {
            formParams.append('cuid', requestParameters['cuid'] as any);
        }

        if (requestParameters['order'] != null) {
            formParams.append('order', requestParameters['order'] as any);
        }


        let urlPath = `/api/Import/upload`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     */
    async importUploadFilePOSTRaw(requestParameters: ImportUploadFilePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportSessionDto>> {
        const requestOptions = await this.importUploadFilePOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportSessionDtoFromJSON(jsonValue));
    }

    /**
     */
    async importUploadFilePOST(requestParameters: ImportUploadFilePOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportSessionDto> {
        const response = await this.importUploadFilePOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
